<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Row style="padding-bottom: 10px;" :gutter="8">
      <Col span="4" style="padding-right: 10px;">
        <Button type="primary" long @click="onClickSearch">检索</Button>
      </Col>
      <Col span="4">
      <Button icon="md-cloud-download" long type="primary" @click="exportMeterInfoTemplate">导出设备模板</Button>
      </Col>
      <Col span="4">
      <Button type="primary" icon="md-cloud-upload" long onclick="$('#upload_file_meter').click();">按设备模板导入</Button>
      </Col>
      <Col span="4">
      <Upload ref="upload" name="upfile" action="/api/importMeterInfoTemplate" :on-success="handleImportMeterInfoTemplate"
          :format="['xlsx','xls']" :show-upload-list="false" :on-error="handleError">
          <input id="upload_file_meter" style="display: none;" />
      </Upload>
      </Col>
    </Row>
    <Table
      ref="selectionTable"
      :max-height="height"
      :data="showData"
      :columns="showColumns"
      stripe
      highlight-row
      border
      @on-current-change="onSelectionTableChange"
    ></Table>
    <Row style="padding:10px 0px 0px 0px">
      <!-- <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="success" @click="onClickInsert">添加{{typeName}}</Button>
      </Col>
      <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="warning" @click="onClickUpdate">修改{{typeName}}</Button>
      </Col>
      <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="error" @click="onClickDelete">删除{{typeName}}</Button>
      </Col>-->
      <Col span="15">
        <Page
          :current="currentPage"
          :total="dataCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          style="text-align:right"
        ></Page>
      </Col>
    </Row>

    <!-- 模态框insert -->
    <Modal v-model="isShowInsertModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>添加{{typeName}}</span>
      </p>
      <Form ref="formInsert" :label-width="110" :rules="ruleInsert" :model="formInsert">
        <FormItem prop="xxxx" label="xxxx：">
          <Input v-model="formInsert.xxxx" placeholder="请输入xxxx..."></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="success" size="large" long :loading="isLoadingButton" @click="commitInsert">添加</Button>
      </div>
    </Modal>

    <!-- 模态框update -->
    <Modal v-model="isShowUpdateModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#ff9900;text-align:center">
        <Icon type="md-create" />
        <span>修改{{typeName}}</span>
      </p>
      <Form ref="formUpdate" :label-width="110" :rules="ruleInsert" :model="formUpdate">
        <FormItem prop="xxxx" label="xxxx：">
          <Input v-model="formUpdate.xxxx" placeholder="请输入xxxx..."></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">修改</Button>
      </div>
    </Modal>

    <!-- 模态框delete -->
    <Modal v-model="isShowDeleteModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#ed4014;text-align:center">
        <Icon type="md-create" />
        <span>删除{{typeName}}</span>
      </p>
      <div style="color:#ed4014;text-align:center">是否确认删除所选{{typeName}}？</div>
      <div slot="footer">
        <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
      </div>
    </Modal>

    <!-- 模态框search -->
    <Modal v-model="isShowModalSearch" :mask-closable="false" width="380">
      <p slot="header" style="color:#2d8cf0;text-align:center">
        <Icon type="md-create" />
        <span>按照输入的字段检索地址</span>
      </p>
      <Form ref="searchParam" :label-width="100" :model="searchParam">
        <FormItem label="关键字：">
          <Input v-model="searchParam.importContent" clearable placeholder="请输入关键字..."></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long @click="commitSearch">检索</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "import_meter_history",
  mounted() {
    this.showColumns = [
      {
        title: "设备编号",
        key: "meterId"
      },
      {
        title: "通讯类型",
        key: "meterCommunicationMode",
        render: function(h, params) {
          return h(
            "div",
            params.row.meterCommunicationMode == "nb"
              ? "NB"
              : params.row.meterCommunicationMode == "wifi"
              ? "WIFI"
              : "NB(电信)"
          );
        }
      },
      {
        title: "用气类型",
        key: "gasTypeName"
      },
      {
        title: "设备类型",
        key: "meterTypeName"
      },
      {
        title: "表厂家",
        key: "meterManufacturer"
      },
      // {
      //   title: "表底数",
      //   key: "meterBaseNumber"
      // },
      {
        title: "设备规格",
        key: "meterSpecifications"
      },
      {
        title: "导入日期",
        key: "meterInsertDatestamp",
        render: function(h, params) {
          return h(
            "div",
            global.dateFtt(
              "yyyy-MM-dd hh:mm:ss",
              new Date(params.row.meterInsertDatestamp)
            )
          );
        }
      },
      {
        title: "设备串号",
        key: "meterSerialNumber"
      },
      {
        title: "NB卡号",
        key: "meterRegisterKey"
      }
    ];
    // this.getMeterType();
    this.showPage();
  },
  data() {
    const validateyyyy = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入yyyy..."));
      } else {
        callback();
      }
    };
    return {
      typeName: "",
      urlClass: "InfoImport",
      height: window.innerHeight,
      isLoadingButton: false,
      isShowInsertModal: false,
      isShowUpdateModal: false,
      isShowDeleteModal: false,
      isShowModalSearch: false,
      isShowTarget: false,
      isSpinShow: false,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [],
      meterTypeData: {},
      selectedData: null,
      formInsert: {},
      formUpdate: {},
      ruleInsert: {
        xxxx: [
          {
            required: true,
            message: "请输入xxxx...",
            trigger: "blur"
          }
        ],
        yyyy: [
          {
            required: true,
            validator: validateyyyy,
            trigger: "change"
          }
        ]
      },
      searchParam: {
        importContent: ""
      },
      meterInfoUrl: "/api/downloadMeterInfoTemplate"
    };
  },
  methods: {
    exportMeterInfoTemplate() {
        window.location.href = this.meterInfoUrl;
    },
    handleImportMeterInfoTemplate(response, file, fileList) {
        console.log(response);
        console.log(file);
        console.log(fileList);
        this.handelResponse(response);
    },
    handelResponse(response) {
        if (response.errorCode != 0) {
            this.$Notice.error({
                title: "导入失败",
                desc: response.errorInfo,
                duration: 0
            });
        } else {
            let result = response.body.repeatArray;
            let insert = response.body.insertArray;
            let count = "\n共计导入" + insert.length + "条数据。";
            let indexs = "";
            if (result.length > 0) {
                result.map(item => {
                    indexs =
                        indexs == "" ? item.index + 2 : indexs + "," + (item.index + 2);
                });
            }
            let msg =
                indexs == "" ?
                "" :
                "\n第" + indexs + "行数据与数据库中数据重复,不予导入。";
            this.$Notice.success({
                title: "成功",
                desc: "导入成功！" + msg + count,
                duration: 0
            });
            this.request();
        }
    },
    handleError(error, file, fileList) {
        console.log(error);
        console.log(file);
        console.log(fileList);
        this.$Notice.error({
            title: "导入失败",
            desc: error,
            duration: 0
        });
    },
    onSelectionTableChange(currentRow) {
      this.selectedData = currentRow;
    },
    onClickInsert() {
      this.isShowInsertModal = true;
    },
    onClickUpdate() {
      if (this.selectedData) {
        this.formUpdate = this.selectedData;
        this.isShowUpdateModal = true;
      } else {
        this.$Notice.warning({
          title: "警告",
          desc: "请选择一条数据！"
        });
      }
    },
    onClickDelete() {
      if (this.selectedData) {
        this.isShowDeleteModal = true;
      } else {
        this.$Notice.warning({
          title: "警告",
          desc: "请选择一条数据！"
        });
      }
    },
    commitInsert() {
      let that = this;
      that.$refs["formInsert"].validate(valid => {
        if (valid) {
          that.isLoadingButton = true;
          $.ajax({
            url: "/api/" + that.urlClass + "/insert",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(that.formInsert),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.showPage();
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isLoadingButton = false;
              that.isShowInsertModal = false;
            }
          });
        }
      });
    },
    commitUpdate() {
      let that = this;
      that.$refs["formUpdate"].validate(valid => {
        if (valid) {
          that.isLoadingButton = true;
          $.ajax({
            url: "/api/" + that.urlClass + "/update",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(that.formUpdate),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.showPage();
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isLoadingButton = false;
              that.isShowUpdateModal = false;
            }
          });
        }
      });
    },
    commitDelete() {
      let that = this;
      that.isLoadingButton = true;
      $.ajax({
        url: "/api/" + that.urlClass + "/delete",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.selectedData),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showPage();
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isLoadingButton = false;
          that.isShowDeleteModal = false;
        }
      });
    },
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/" +
          that.urlClass +
          "/selectMeterPage?page=" +
          that.currentPage +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.searchParam),
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.resultList;
          that.dataCount = data.body.amount;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    onClickSearch() {
      this.isShowModalSearch = true;
    },
    commitSearch() {
      console.log(this.searchParam);
      this.isShowModalSearch = false;
      this.showPage();
    },
    getMeterType() {
      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/getMeterTypeInfo",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          console.log(data);
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          let typeList = data.body.resultList;
          for (let i = 0; i < typeList.length; i++) {
            that.meterTypeData[typeList[i]["id"]] = typeList[i];
          }

          console.log(that.meterTypeData);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    }
  }
};
</script>

<style>
</style>
